<template>
  <div class="content">
    <CustomTable ref="CustomTable" v-loading="loading" @init="init" @handelBtnClick="handelBtnClick"
      @handelTableChange="handelTableChange" @handelTableClick="handelTableClick" :filterData="filterData"
      :headerData="headerData" :btnsData="btnsData" :data="data" :pagination="pagination">
      <el-table-column label="操作" fixed="right" align="center" width="180px">
        <template slot-scope="scope">
          <el-link @click="handelTableClick(scope.row, 'edit')">编辑</el-link>
          <el-popconfirm title="确定删除吗？" @confirm="handelTableClick(scope.row, 'delete')">
            <el-link slot="reference">删除</el-link>
          </el-popconfirm>
          <el-popconfirm title="确定重置密码吗？" @confirm="handelTableClick(scope.row, 'reset')">
            <el-link slot="reference">重置密码</el-link>
          </el-popconfirm>
        </template>
      </el-table-column>
    </CustomTable>
    <CustomUpload ref="CustomUpload" :url="uploadUrl" :hideUpload="true" @handelChange="handelChange" />
    <el-dialog :title="createdType == 'add' ? '新增单位会员' : '修改单位会员'" :visible.sync="dialogVisible" width="800px"
      :close-on-click-modal="false">
      <CustomForm ref="CustomForm" :data="addFormData" @change="handelForm" />
    </el-dialog>

    <el-dialog title="重置密码提醒" :visible.sync="resetDialogVisible">
      <p style="padding: 20px;text-align: center;">{{ resetDialogMessage }}</p>
    </el-dialog>
  </div>
</template>

<script>
import CustomForm from "@/components/custom/CustomForm";
import CustomTable from "@/components/custom/CustomTable";
import CustomUpload from "@/components/custom/CustomUpload";
export default {
  components: { CustomForm, CustomTable, CustomUpload },
  data() {
    return {
      uploadUrl: this.$api.Members.institutionalImport,
      filterData: [
        { label: "会员单位名称", prop: "name", type: "input", span: 12 },
        // { label: "会员单位邮箱", prop: "email", type: "input", span: 12 },
        {
          label: "预备单位会员",
          prop: "perMember",
          type: "select",
          span: 6,
          opt: [
            { label: "是", value: true },
            { label: "否", value: false },
          ],
        },
        {
          label: "是否付费",
          prop: "pay",
          type: "select",
          span: 6,
          opt: [
            { label: "是", value: true },
            { label: "否", value: false },
          ],
        },
        {
          label: "审核状态",
          prop: "auditingStatus",
          type: "select",
          value: "",
          span: 6,
          opt: [
            { label: "通过", value: "PASS" },
            { label: "不通过", value: "FAIL" },
            { label: "待审核", value: "PADDING" },
          ],
        },
        {
          label: "状态",
          prop: "status",
          type: "select",
          value: "",
          span: 6,
          opt: [
            { label: "启用", value: true },
            { label: "禁用", value: false },
          ],
        },
      ],
      headerData: [
        { label: "排序", prop: "sortOrder" },
        { label: "单位名称", prop: "name" },
        // { label: "单位邮箱", prop: "email" },
        { label: "预备单位会员", prop: "perMember", type: "switch" },
        { label: "是否付费", prop: "pay", type: "switch" },
        {
          label: "审核状态",
          prop: "auditingStatus",
          type: "audit",
          opt: [
            { label: "通过", value: "PASS" },
            { label: "不通过", value: "FAIL", check: true },
            // { label: "待审核", value: "PADDING" },
          ],
        },
        { label: "状态", prop: "status", type: "switch" },
      ],
      btnsData: [
        { label: "新增", value: "add", type: "primary" },
        { label: "导入", value: "improt" },
        { label: "导出", value: "export" },
        { label: "下载导入模板", value: "exportTemplate" },
      ],
      data: [],
      addFormData: [
        {
          label: "会员单位名称",
          prop: "name",
          value: "",
          type: "input",
          required: true,
          span: 24,
        },
        {
          label: "LOGO",
          prop: "img",
          type: "upload",
          value: [],
          required: false,
          span: 24,
        },
        // {
        //   label: "会员单位邮箱",
        //   prop: "email",
        //   value: "",
        //   type: "input",
        //   required: true,
        //   span: 12,
        // },
        {
          label: "职工人数",
          prop: "workerCount",
          value: "",
          type: "number",
          required: false,
          span: 12,
        },
        {
          label: "单位法人姓名",
          prop: "legalPersonName",
          value: "",
          type: "input",
          required: true,
          span: 12,
        },
        {
          label: "单位法人手机",
          prop: "legalPersonMobile",
          value: "",
          type: "input",
          required: true,
          span: 12,
        },
        {
          label: "单位法人电话",
          prop: "legalPersonPhone",
          value: "",
          type: "input",
          required: false,
          span: 12,
        },
        {
          label: "联络员姓名",
          prop: "contactPersonName",
          value: "",
          type: "input",
          required: false,
          span: 12,
        },
        {
          label: "联络员电话",
          prop: "contactPersonPhone",
          value: "",
          type: "input",
          required: false,
          span: 12,
        },
        {
          label: "联络员手机",
          prop: "contactPersonMobile",
          value: "",
          type: "input",
          required: false,
          span: 12,
        },
        {
          label: "教授高工人数",
          prop: "proEngineerCount",
          value: "",
          type: "number",
          required: false,
          span: 12,
        },
        {
          label: "高工人数",
          prop: "seniorEngineerCount",
          value: "",
          type: "number",
          required: false,
          span: 12,
        },
        {
          label: "工程师人数",
          prop: "engineerCount",
          value: "",
          type: "number",
          required: false,
          span: 12,
        },
        {
          label: "技术员人数",
          prop: "technicianCount",
          value: "",
          type: "number",
          required: false,
          span: 12,
        },
        {
          label: "单位地址",
          prop: "address",
          value: "",
          type: "input",
          required: false,
          span: 24,
        },
        {
          label: "单位电话",
          prop: "phone",
          value: "",
          type: "input",
          required: false,
          span: 12,
        },
        {
          label: "邮政编码",
          prop: "postalCode",
          value: "",
          type: "input",
          required: false,
          span: 12,
        },
        {
          label: "单位获奖经历",
          prop: "awards",
          value: "",
          type: "editor",
          required: false,
          span: 24,
        },
        {
          label: "排序",
          prop: "sortOrder",
          value: "0",
          type: "number",
          required: false,
          span: 12,
        },
      ],
      loading: false,
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
      selectData: {},
      dialogVisible: false,
      createdType: "",
      resetDialogVisible: false,
      resetDialogMessage: ""
    };
  },
  methods: {
    handelChange() {
      this.$refs.CustomTable.search();
    },
    handelTableChange(data) {
      let url = "";
      let params = {};
      let ajaxType = "get";
      switch (data.prop) {
        case "status":
          url = this.$api.Members.institutionalStatus;
          params = {
            status: data.data.status ? "active" : "inactive",
          };
          break;
        case "auditingStatus":
          url = this.$api.Members.institutionalAuditing;
          params = data.value;
          ajaxType = "post";
          break;
        case "perMember":
          url = this.$api.Members.institutionalPreMember;
          params = {
            isPre: data.data.perMember,
          };
          break;
        case "pay":
          url = this.$api.Members.institutionalIspay;
          params = {
            isPay: data.data.pay,
          };
          break;
      }
      this.$https[ajaxType](url + data.data.id, params).then((res) => {
        this.$message.success("修改成功");
        this.$refs.CustomTable.search();
      });
    },
    handelForm(data) {
      if (!Object.keys(data).length) {
        this.dialogVisible = false;
        return;
      }
      let params = Object.assign({}, data);
      params.img = params.img.length ? params.img[0] : "";
      const url =
        this.createdType == "add"
          ? this.$api.Members.institutionalAdd
          : this.$api.Members.institutionalUpdate + this.selectData.id;
      this.$https.post(url, params).then((res) => {
        this.$message.success(
          this.createdType == "add" ? "新增正常" : "修改成功"
        );
        this.dialogVisible = false;
        this.$refs.CustomTable.search();
      });
    },
    handelTableClick(data, type) {
      this.createdType = type;
      switch (type) {
        case "reset":
          this.$https
            .get(this.$api.Members.resetrootpass + data.id)
            .then((res) => {
              this.$message.success("重置成功");
              this.resetDialogVisible = true;
              this.resetDialogMessage = res.result;
              // this.$message.success("重置成功!"+res.result);
              this.$refs.CustomTable.search();
            });
          break;
        case "delete":
          this.$https
            .get(this.$api.Members.institutionalDelete + data.id)
            .then((res) => {
              this.$message.success("删除成功");
              this.$refs.CustomTable.search();
            });
          break;
        case "edit":
          this.selectData = data;
          this.$https
            .get(this.$api.Members.institutionalDetails + data.id)
            .then((res) => {
              this.addFormData = this.addFormData.map((el) => {
                return Object.assign(el, {
                  value:
                    el.prop == "img"
                      ? res[el.prop]
                        ? [res[el.prop]]
                        : []
                      : res[el.prop] || el.value,
                });
              });
              this.dialogVisible = true;
            });
          break;
      }
    },
    handelBtnClick(type) {
      this.createdType = type;
      switch (type) {
        case "add":
          this.addFormData = [
            {
              label: "会员单位名称",
              prop: "name",
              value: "",
              type: "input",
              required: true,
              span: 24,
            },
            {
              label: "LOGO",
              prop: "img",
              type: "upload",
              value: [],
              required: false,
              span: 24,
            },
            // {
            //   label: "会员单位邮箱",
            //   prop: "email",
            //   value: "",
            //   type: "input",
            //   required: true,
            //   span: 12,
            // },
            {
              label: "职工人数",
              prop: "workerCount",
              value: "",
              type: "number",
              required: false,
              span: 12,
            },
            {
              label: "单位法人姓名",
              prop: "legalPersonName",
              value: "",
              type: "input",
              required: true,
              span: 12,
            },
            {
              label: "单位法人手机",
              prop: "legalPersonMobile",
              value: "",
              type: "input",
              required: true,
              span: 12,
            },
            {
              label: "单位法人电话",
              prop: "legalPersonPhone",
              value: "",
              type: "input",
              required: false,
              span: 12,
            },
            {
              label: "联络员姓名",
              prop: "contactPersonName",
              value: "",
              type: "input",
              required: false,
              span: 12,
            },
            {
              label: "联络员电话",
              prop: "contactPersonPhone",
              value: "",
              type: "input",
              required: false,
              span: 12,
            },
            {
              label: "联络员手机",
              prop: "contactPersonMobile",
              value: "",
              type: "input",
              required: false,
              span: 12,
            },
            {
              label: "教授高工人数",
              prop: "proEngineerCount",
              value: "",
              type: "number",
              required: false,
              span: 12,
            },
            {
              label: "高工人数",
              prop: "seniorEngineerCount",
              value: "",
              type: "number",
              required: false,
              span: 12,
            },
            {
              label: "工程师人数",
              prop: "engineerCount",
              value: "",
              type: "number",
              required: false,
              span: 12,
            },
            {
              label: "技术员人数",
              prop: "technicianCount",
              value: "",
              type: "number",
              required: false,
              span: 12,
            },
            {
              label: "单位地址",
              prop: "address",
              value: "",
              type: "input",
              required: false,
              span: 24,
            },
            {
              label: "单位电话",
              prop: "phone",
              value: "",
              type: "input",
              required: false,
              span: 12,
            },
            {
              label: "邮政编码",
              prop: "postalCode",
              value: "",
              type: "input",
              required: false,
              span: 12,
            },
            {
              label: "单位获奖经历",
              prop: "awards",
              value: "",
              type: "editor",
              required: false,
              span: 24,
            },
            {
              label: "排序",
              prop: "sortOrder",
              value: "0",
              type: "number",
              required: false,
              span: 12,
            },
          ];
          this.dialogVisible = true;
          break;
        case "improt":
          this.$refs.CustomUpload.handleCallUpload();
          break;
        case "export":
          this.$https
            .post(
              this.$api.Members.institutionalExport,
              {},
              { responseType: "arraybuffer" }
            )
            .then((res) => {
              let a = document.createElement("a");
              //ArrayBuffer 转为 Blob
              let blob = new Blob([res], { type: "application/vnd.ms-excel" });
              let objectUrl = URL.createObjectURL(blob);
              a.setAttribute("href", objectUrl);
              a.setAttribute("download", "单位会员名单.xlsx");
              a.click();
            });
          break;
        case "exportTemplate":
          // 创建一个<a></a>标签
          const a = document.createElement("a");
          a.href = window.location.pathname + "unitTemplate.xlsx";
          a.download = "单位会员导入模板.xlsx";
          // 障眼法藏起来a标签
          a.style.display = "none";
          // 将a标签追加到文档对象中
          document.body.appendChild(a);
          // 模拟点击了<a>标签,会触发<a>标签的href的读取,浏览器就会自动下载了
          a.click();
          // 一次性的,用完就删除a标签
          a.remove();
          break;
      }
    },
    init(data) {
      this.loading = true;
      let params = data;
      if (params && Object.keys(params).includes("status")) {
        params.status = params.status ? "active" : "inactive";
      }
      params.current -= 1;
      this.$https
        .get(this.$api.Members.institutionalList, params)
        .then((res) => {
          this.pagination = {
            pageSize: res.pageSize,
            current: res.currentPage + 1,
            total: res.count,
          };
          this.data = res.data
            ? res.data.map((el) => {
              return Object.assign(el, {
                status: el.status == "active" ? true : false,
                auditingStatus:
                  el.auditingStatus == "PADDING" ? "" : el.auditingStatus,
              });
            })
            : [];
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  position: relative;
  width: 100%;
  overflow: hidden;
}

/deep/.el-dialog__body {
  padding: 0;
}
</style>